import { DropdownOption } from './DropdownOption';

export class DropdownOptionsGroup<Value = number, Name extends string = string> {
  public readonly name: Name;
  public readonly list: Array<DropdownOption<Value>>;

  public constructor(name: Name, list: Array<DropdownOption<Value>>) {
    this.list = list;
    this.name = name;
  }
}
